export const blogQuery = /* GraphQL */ `
    query GetPosts(
        $currentPage: Int
        $pageSize: Int
        $searchQuery: String
        $publishTime: String
        $allPosts: Boolean
        $authorId: String
        $sortFiled: String
    ) {
        blogPosts(
            allPosts: $allPosts
            currentPage: $currentPage
            pageSize: $pageSize
            sort: ["DESC"]
            sortFiled: $sortFiled
            filter: {
                search: { eq: $searchQuery }
                publish_time: { eq: $publishTime }
                author_id: { eq: $authorId }
            }
        ) {
            total_count
            items {
                identifier
                publish_time
                post_id
                featured_image
                featured_list_image
                title
                short_filtered_content
                meta_title
                meta_keywords
                meta_description
                author {
                    author_id
                    name
                    author_url
                }
                post_url
                creation_time
                modified_time
                tags {
                    tag_id
                    title
                    tag_url
                }
                categories {
                    category_id
                    title
                    category_url
                    identifier
                }
            }
            total_pages
        }
    }
`

export const sideblogCategory = /* GraphQL */ `
    query blogCategories {
        blogCategories {
            items {
                identifier
                category_id
                title
                posts_count
                parent_category_id
                category_url
            }
        }
    }
`
export const singlePost = /* GraphQL */ `
    query GetPost($postId: String) {
        blogPost(id: $postId) {
            post_id
            meta_title
            meta_description
            featured_image
            featured_list_image
            title
            filtered_content
            author {
                author_id
                name
                author_url
            }
            post_url
            creation_time
            modified_time
            publish_time
            tags {
                tag_id
                title
                tag_url
            }
            categories {
                category_id
                title
                category_url
                identifier
            }
        }
    }
`

export const categorypost = /* GraphQL */ `
    query GetPosts($currentPage: Int, $pageSize: Int, $categoryId: String) {
        blogPosts(
            currentPage: $currentPage
            pageSize: $pageSize
            sort: ["DESC"]
            sortFiled: "modified_time"
            filter: { category_id: { eq: $categoryId } }
        ) {
            total_count
            items {
                identifier
                featured_image
                featured_list_image
                post_id
                title
                short_filtered_content
                author {
                    author_id
                    name
                    author_url
                }
                post_url
                creation_time
                modified_time
                publish_time
                tags {
                    tag_id
                    title
                    tag_url
                }
                categories {
                    category_id
                    title
                    category_url
                    identifier
                }
            }
            total_pages
        }
        blogCategory(id: $categoryId) {
            title
            content
        }
    }
`

export const recentpost = /* GraphQL */ `
    query GetPosts($pageSize: Int) {
        blogPosts(
            pageSize: $pageSize
            sort: ["DESC"]
            sortFiled: "modified_time"
        ) {
            items {
                creation_time
                modified_time
                publish_time
                identifier
                featured_image
                featured_list_image
                post_id
                title
                post_url
            }
        }
    }
`

export const RelatedPostQuery = `
  query GetPost ($postId: String) {
    blogPost (id: $postId) {
        post_id
        meta_title
        meta_description
        title
        filtered_content
        author {
            author_id
            name
            author_url
        }
        creation_time
        publish_time
        modified_time
        related_posts{
            update_time
            identifier
            featured_image
            featured_list_image
            post_id
            title
            post_url
        }
    }
  }
`

export const BLOG_COMMENT = /* GraphQL */ `
    mutation addComment(
        $author_email: String!
        $author_nickname: String!
        $parent_id: Int!
        $post_id: Int!
        $text: String!
    ) {
        addCommentToPost(
            input: {
                author_email: $author_email
                author_nickname: $author_nickname
                parent_id: $parent_id
                post_id: $post_id
                text: $text
            }
        ) {
            total_count
            total_pages
            comments {
                post_id
                comment_id
                parent_id
                customer_id
                admin_id
                status
                author_type
                author_nickname
                author_email
                text
                creation_time
                update_time
            }
        }
    }
`
export const GETPOSTCOMMENTS = `
 query blogComments ($post_id: String) {
    blogComments (filter: {post_id: {eq: $post_id}}) {
        total_count
        items {
          post_id
          comment_id
          parent_id
          customer_id
          admin_id
          status
          author_type
          author_nickname
          author_email
          text
          creation_time
          update_time
        }
        total_pages
    }
}
`

export const GetAllBlogQuery = /* GraphQL */ `
    query GetPosts($allPosts: Boolean) {
        blogPosts(
            allPosts: $allPosts
            sort: ["DESC"]
            sortFiled: "modified_time"
        ) {
            total_count
            items {
                identifier
                post_id
                post_url
                creation_time
                modified_time
                publish_time
            }
            total_pages
        }
    }
`
export const seoQuery = `
    query GetPost($postId: String) {
        blogPost(id: $postId) {
            title
            meta_title
            meta_keywords
            meta_description
            og_title
            og_description
            og_image
            og_type
            canonical_url
            author {
                name
                author_url
                url
            }
            publish_time
            modified_time
            short_content
            featured_image
            author {
             name
            }
            media_gallery
            update_time
        }
    }
`

export const seoCategoryQuery = `
    query GetPost($categoryId: String) {
        blogCategory(id: $categoryId) {
            title
            meta_title
            meta_keywords
            meta_description
            canonical_url
        }
    }
`

export const seoAuthorQuery = `
    query GetPost($authorId: String) {
        blogAuthor(id: $authorId) {
            title
            meta_title
            meta_description
        }
    }
`

export const seoBlogPageQuery = `
  query {
    storeConfig {
      mfblog_index_page_title
      mfblog_index_page_meta_title
      mfblog_index_page_meta_description
      mfblog_index_page_meta_keywords
    }
  }
`
export const GetRelatedBlogQuery = /* GraphQL */ `
    query GetRelatedBlog(
        $currentPage: Int
        $pageSize: Int
        $productId: String
    ) {
        blogPosts(
            currentPage: $currentPage
            pageSize: $pageSize
            sort: ["ASC"]
            filter: { relatedproduct_id: { eq: $productId } }
        ) {
            total_count
            items {
                identifier
                featured_image
                featured_list_image
                post_id
                title
                short_filtered_content
                author {
                    author_id
                    name
                    author_url
                }
                post_url
                creation_time
                modified_time
                publish_time
                tags {
                    tag_id
                    title
                    tag_url
                }
                categories {
                    category_id
                    title
                    category_url
                    identifier
                }
            }
            total_pages
        }
    }
`
